import React from 'react'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Image } from 'src/components/ui/Image'
import { useMobile } from 'src/hooks/useMobile'

interface ImageItem {
  image: string
}

interface CorporateProps {
  cards: ImageItem[]
  title: string
  description: string
  buttonText: string
  buttonLink: string
}

const CartaoPresenteCorporate: React.FC<CorporateProps> = ({
  cards,
  title,
  description,
  buttonText,
  buttonLink,
}) => {
  const { isMobile } = useMobile()

  return (
    <section className="w-full max-w-[1440px] self-center justify-self-center text-black my-[100px] relative bg-[#2E2F35]">
      <div className="max-w-[1440px] mx-auto flex md:overflow-hidden flex-col md:flex-row items-center gap-10">
        <div className="w-full md:w-1/2 justify-center relative md:-left-[250px] flex gap-4">
          {cards.map((card, idx) => {
            if (idx === 1 && isMobile) {
              return null
            }

            return (
              <Image
                key={idx}
                src={card.image}
                alt={`Imagem ${idx + 1}`}
                className="rounded-xl shadow-lg relative -top-10 md:top-0 object-cover md:w-full w-[340px] h-[210px] md:h-[400px]"
              />
            )
          })}
        </div>

        <div className="w-full md:w-1/2 md:p-[120px] p-5 flex flex-col gap-4">
          <h2 className="md:text-4xl text-white text-3xl font-bold">{title}</h2>
          <p className="text-white md:text-base">{description}</p>
          <FlexibleLink
            linkUrl={buttonLink}
            classNames="mt-4 w-full text-lg inline-block text-center text-white content-center px-4 md:w-[320px] h-[64px] py-1 bg-[#3643BA] rounded-full font-semibold"
            label={buttonText}
          />
        </div>
      </div>
    </section>
  )
}

export default CartaoPresenteCorporate
